export default function () {
  if (
    Array.from(
      document.querySelectorAll(
        '.PageMain--obesity-center .ObesityCenter__container'
      )
    ).length > 0
  ) {
    import(
      /* webpackChunkName: "obesity-center-module" */ './obesity-center'
    ).then((module) => {
      const ObesityCenter = module.default
      ObesityCenter()
    })
  }
}
